import { Navigate, Outlet, useParams } from "react-router";
import { isOriginalSlug } from "@laftel-ip-originals/notion/originals";

export function OriginalRouteGuard() {
  const { slug } = useParams<{ slug: string }>();
  if (!isOriginalSlug(slug)) {
    return <Navigate to="/" replace />;
  }
  return <Outlet />;
}
